import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// planejamentoHoras.service.js — r79
// (renomeado de planejamento.service.js pra não conflitar com a rotina
//  original de Planejamento de Projeto — vide r78/r79 LEIA-ME)
// ════════════════════════════════════════════════════════════════════════════

const planejamentoHorasService = {
  // Calcula dias elegíveis + feriados + conflitos (sem persistir)
  preview: async (payload) => {
    const res = await api.post('/planejamento-horas/preview', payload);
    return res.data;
  },

  // Persiste os blocos (após confirmação no front)
  salvar: async (payload) => {
    const res = await api.post('/planejamento-horas/salvar', payload);
    return res.data;
  },

  // Lista lançamentos de um colaborador/mês pra renderizar o calendário
  calendario: async (params) => {
    const res = await api.get('/planejamento-horas/calendario', {
      params: { ...params, _t: Date.now() },
    });
    return res.data;
  },

  // Próximos 12 períodos NÃO fechados (cria os que não existem como 'A')
  periodosDisponiveis: async () => {
    const res = await api.get('/planejamento-horas/periodos-disponiveis', {
      params: { _t: Date.now() },
    });
    return res.data;
  },
};

export default planejamentoHorasService;
